import {
  textFormatEditor,
  generateColumn,
} from "./../../../../../utils/commonFunctions";
import type { ColDef } from "ag-grid-community";
import {
  idColumn,
  nameColumn,
  actionColumn,
  statusColumn,
  codeColumn,
} from "../../../../../utils/commonColumns";

const columnDefs: ColDef[] = [
  idColumn,
  codeColumn,
  {
    ...generateColumn("", "industry_name"),
    ...textFormatEditor("industry_name"),
  },
  nameColumn,
  {
    ...generateColumn("", "description"),
    ...textFormatEditor("description"),
  },
  statusColumn,
  actionColumn,
];
export default columnDefs;
